var _circle, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrFrance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 44,
    viewBox: "0 0 45 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3445_26543",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 45,
    height: 44
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.7841,
    cy: 21.7841,
    r: 21.7841,
    transform: "matrix(1 0 0 -1 0.841797 43.5681)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3445_26543)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.5227,
    height: 43.5682,
    transform: "matrix(1 0 0 -1 0.841797 43.5681)",
    fill: "#004692"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14.5227,
    height: 43.5682,
    transform: "matrix(1 0 0 -1 15.3652 43.5681)",
    fill: "#F5F7F8"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14.5227,
    height: 43.5682,
    transform: "matrix(1 0 0 -1 29.8867 43.5681)",
    fill: "#DD2033"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrFrance);
export default __webpack_public_path__ + "static/media/FR France.29030c8fc20978d44df28e95920676e1.svg";
export { ForwardRef as ReactComponent };